import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-home.jpeg";
import { ptBR } from "date-fns/esm/locale";

import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { BiSearch } from "react-icons/bi"

import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { Container } from '../../theme/styles';
import { MainBanner } from "../../components/MainBanner";
import { createRef, RefObject, useState } from "react";
import { Label } from "../../components/Forms";
import { Input } from "../../components/Input";
import { useEvents, Response, Submit, Search } from "./helpers/submit";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw'
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

type MonthData = {
  title: string;
  ref: RefObject<HTMLSpanElement>;
  results: any[];
};

type YearData = {
  year: number;
  ref: RefObject<HTMLSpanElement>;
  months: MonthData[];
}

type YearsView = {
  current: YearData;
  next: YearData;
}

function Agenda() {
  usePageTrack();

  function daysInMonth (month: number, year: number) {
    return new Date(year, month, 0).getDate();
  }

  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];

  const now = new Date();
  const [title, setTitle] = useState(months[now.getMonth()]);
  const [searchText, setSearchText] = useState("");
  const [currentDate, setCurrentDate] = useState(now);
  const [events, setEvents] = useState<Response|null>(null);
  const firstData: Response = useEvents(buildSearch('', now));

  const mountYearsView = (date = currentDate): YearsView => {
    const mount = (year: number): YearData => {
      return {
        year: year,
        ref: createRef(),
        months: months.map((name): MonthData => {
          return {
            title: name,
            ref: createRef(),
            results: []
          }
        })

      }
    }

    return {
      current: mount(date.getFullYear()),
      next: mount(date.getFullYear() + 1)
    }
  }

  //const [years, setYears] = useState<Record<string, YearData>>({'2022': mountYear(2022)});
  const [years, setYears] = useState<YearsView>(mountYearsView());

  const HandleSelectDay = (date: string | Date | null) => {
    console.log("HandleSelectDay");
    const selected = new Date(date? date : '');
    if(title !== months[selected.getMonth()]) {
      setTitle(months[selected.getMonth()]);
    }
  }

  const HandleSelectMonth = async (date: string | Date | null) => {
    console.log("HandleSelectMonth", date);

    // if(currentDate.toISOString().split('T')[0] !== now.toISOString().split('T')[0]) {
    //   setCurrentDate(now);
    // }

    const selected = new Date(date? date : '');
    if(currentDate.toISOString().split('T')[0] !== selected.toISOString().split('T')[0]) {
      setCurrentDate(selected);
      setYears(mountYearsView(selected))
    }
    setTitle(months[selected.getMonth()]);


    // if(!canMove) {
    //   setCanMove(true);
    //   return;
    // }
    // const ref = years.current.months[selected.getMonth()].ref;
    // ref?.current!.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'center',
    //   inline: 'start',
    // });
  }

  const HandleSelectYear = async (date: string | Date | null) => {
    console.log("HandleSelectYear", date);
    const selected = new Date(date? date : '');

    // setTimeout(function delay() {
    //   const ref = years.current.ref;
    //   ref?.current!.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'center',
    //     inline: 'start',
    //   });
    // }, 3000);

    if(currentDate.toISOString().split('T')[0] !== selected.toISOString().split('T')[0]) {

      setCurrentDate(selected);
      setYears(mountYearsView(selected))
      const search: Search = buildSearch('', selected);
      const result: Response = await submit(search);
      setEvents(result);
    }
  }

  const HandlePreviousYear = async () => {
    console.log("HandlePreviousYear");

    await HandleSelectYear(`${years.current.year - 1}-01-15`)
  }

  const HandleNextYear = async () => {
    console.log("HandleNextYear");

    await HandleSelectYear(`${years.next.year}-01-15`)
  }

  function buildSearch(searchText: string = '', date: string|Date = '') {
    const search: Search = {}
    if (date) {
      const d = new Date(date);
      const monthDays = daysInMonth(12, d.getFullYear());
      // let strMonth = `${d.getMonth()+1}`;
      // strMonth = strMonth.length < 2? '0'+strMonth : strMonth;
      search.initialDate = `${d.getFullYear()}-01-01`
      search.finalDate = `${d.getFullYear()+1}-12-${monthDays}`
    }
    if(searchText){
      search.buscaLivre = searchText;
    }

    return search;
  }

  async function submit(search: Search) {
    return await Submit(search);
  }

  async function onSubmit(e: any) {
    console.log('submit')
    e.preventDefault();
    setTitle('Pesquisa')
    const result: Response = await submit(buildSearch(searchText));
    // if (result?.results?.length && result.results[0].initial_date) {
    //   setCurrentDate(new Date(result.results[0].initial_date));
    // }
    setEvents(result);
  }

  const localResults = (year: number, indexMonth: number) => {
    return ((events || firstData).results.filter(({initial_date}, i, u) => {
      const d = new Date(initial_date)
      return d.getMonth() === indexMonth && d.getFullYear() === year;
    }))
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Content>
        <CalendarPicker>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              openTo="month"
              views={["year", "month"]}
              value={currentDate}
              componentsProps={{
                leftArrowButton: {
                  'onClick': HandlePreviousYear,
                  'title': 'Ano Anterior',
                  'aria-label': 'Ano Anterior'
                },
                rightArrowButton: {
                  'onClick': HandleNextYear,
                  'title': 'Ano Seguinte',
                  'aria-label': 'Ano Seguinte'
                },
              }}
              //onChange={() => console.log('change day')}
              onChange={(value) => HandleSelectDay(value)}
              onMonthChange={(value) => HandleSelectMonth(value)}
              onYearChange={(value) => HandleSelectYear(value)}
              renderInput={(params) => <TextField {...params} />}      
            />
          </LocalizationProvider>
          <Form onSubmit={onSubmit}>
            <Label>Busca Padrão</Label>
            <Field>
              <Input 
                type="text" 
                placeholder="Pesquisar" 
                value={searchText}
                onChange={(value) => setSearchText(value)}
              />
              <Button>
                <BiSearch size={28} color="#fff" />
              </Button>
            </Field>
          </Form>
        </CalendarPicker>
        <CalendarDays>
        {Object.values(years).map(({months, year, ref}) => (
          <>
          {(year !== years.current.year)? (
            <Title ref={ref} style={{fontSize: '45pt', paddingBottom: '10px'}}>{ year }</Title>
          ):('')}

            {months.map((month, index) => 
              (index >= currentDate.getMonth() || year !== years.current.year)? (
                <>
                  <Title ref={month.ref}>{ `${month.title}` }</Title>
                  <CalendarWrapper>
                    {/* {new Array(currentMonthDays).fill(1).map((day, index) => ( */}
                    {(localResults(year, index).length)? localResults(year, index).map((event, index) => (
                      <CalendarDay>
                        <Day>{new Date(event.initial_date).getUTCDate()}</Day>
                        <Event>
                          <EventTitle>{`${event.title} - ${new Date(event.initial_date).toLocaleDateString()}`}</EventTitle>
                          <EventDescription>
                            <ReactMarkdown rehypePlugins={[rehypeRaw]} children={event.description} />
              
                          </EventDescription>
                        </Event>
                      </CalendarDay>
                    )) : (
                      <NoResults>
                        Sem Eventos
                      </NoResults>
                    )}
                  </CalendarWrapper>
                </>
              ):('')

            )}
          </>
        ))}
        </CalendarDays>
      </Content>
      <Footer />
    </>
  )
}

export default Agenda;

const Content = styled(Container)`
  display: flex;
  padding: 32px 14px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column-reverse;
  }
`;

const CalendarPicker = styled.div`
  width: calc(25% - 12px);

  div[role="presentation"] {
    //pointer-events: none;

    > button {
      //display: none;
    }
  }

  .PrivatePickersMonth-root {
    /* margin 0 18px; */
    max-width: 57px
  }

  .MuiPickersArrowSwitcher-root {
    opacity: 1 !important;
    visibility: visible !important;
  }

  .MuiPickersCalendarHeader-labelContainer {
    margin-right: 20px;
  }

  .MuiCalendarPicker-root {
    transform: translateX(-22px);

    > div:first-child {
      padding-left: 34px;
      padding-right: 22px;
      margin-top: 0;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    margin-top: 64px;

    .MuiCalendarPicker-root {
      transform: none;
    }
  }
`;

const CalendarDays = styled.div`
  width: calc(75% - 2px);
  padding-left: 64px;
  overflow: auto;
  max-height: 800px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    padding: 0;
  }
`;

const Form = styled.form`
  padding-top: 20px;
`;

const Field = styled.div`
  display: flex;
`;

const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.blue.dark};
  border: none;
  border-radius: 5px;
  width: 80px;
  margin-left: 8px;
`;

const Title = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.gray.darker};
  font-size: 32px;
  line-height: 1;
  margin-bottom: 16px;
`

const CalendarWrapper = styled.div`
  //height: 1000px;
  min-height: 80px;
  overflow: auto;
`;

const CalendarDay = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray.dark};
  padding: 8px 0;
  min-height: 80px;
  display: flex;
`;

const Day = styled.span`
  font-family: 'Coolvetica Condensed', Arial, Helvetica, sans-serif;
  color: ${({ theme }) => theme.colors.gray.darker};
  padding: 0 12px 0 2px;
  width: 30px;
  display: ${({ hidden }) => hidden? 'none' : 'block'};
`;

const Event = styled.div`
  background-color: ${({ theme }) => theme.colors.pink.light};
  border:  2px solid ${({ theme }) => theme.colors.blue.darker};
  padding: 8px;
  border-radius: 3px;
  width: 100%;
`;

const EventTitle = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.blue.darker};
  font-size: 16px;
`;

const EventDescription = styled.span`
  display: block;
  color: #fff;
  font-size: 13px;
`;

const NoResults = styled.span`
  display: block;
  text-align: left;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.darker };
`;
